import React from "react";
import { ArrowRight, Scale, Shield, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function BuroProfilimiz() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="büro-profilimiz" className="dark bg-[#0a0c10] text-foreground py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1e1e1e]/5 to-transparent pointer-events-none" />
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-amber-900/5 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-900/5 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2 pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div ref={containerRef} className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {}
          <div className={cn("lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-900/20 border border-amber-700/30 text-amber-500/90 text-xs font-medium tracking-wider uppercase w-fit">
                <Clock className="w-3 h-3" />
                <span>2017'den Beri</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold leading-tight text-slate-300">
                Hukukun Üstünlüğü ve <br />
                <span className="text-slate-400">Mesleki Yetkinlik</span>
              </h2>
            </div>

            <div className="prose prose-lg prose-invert text-slate-400 font-sans max-w-none space-y-6">
              <p>
                Av. Arb. Muhammed Çelik Hukuk ve Arabuluculuk Bürosu, 2017 yılında Isparta'da kurulmuş olup, kurulduğu günden bu yana hukukun evrensel ilkeleri ışığında müvekkillerine kesintisiz hizmet sunmaktadır.
              </p>
              <p>
                Büromuz; Ceza Hukuku, Aile ve Boşanma Hukuku, Şirketler Hukuku ve Gayrimenkul Hukuku başta olmak üzere geniş bir yelpazede faaliyet göstermektedir. Temel prensibimiz, her hukuki uyuşmazlığı kendi dinamikleri içinde değerlendirerek, müvekkillerimize en doğru, hızlı ve etkili hukuki çözümleri sunmaktır.
              </p>
              <p>
                Mesleki etik kurallara tam bağlılık ve şeffaflık ilkesiyle hareket eden ofisimiz, yargılama süreçlerinin her aşamasında müvekkillerini bilgilendirmeyi ve güven ilişkisini en üst düzeyde tutmayı amaçlar. Isparta merkezli ofisimiz, yerel dinamiklere hakimiyeti ve güncel hukuki gelişmeleri yakından takibi ile tanınmaktadır.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="flex gap-4 items-start">
                <div className="p-3 rounded-lg bg-amber-900/20 text-amber-500/90">
                  <Scale className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-lg font-serif font-semibold text-slate-300 mb-1">Adil Çözümler</h4>
                  <p className="text-sm text-slate-400 font-sans">
                    Her dosyada titiz bir çalışma ile adaletin tecellisi için mücadele ediyoruz.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="p-3 rounded-lg bg-amber-900/20 text-amber-500/90">
                  <Shield className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-lg font-serif font-semibold text-slate-300 mb-1">Güven ve Gizlilik</h4>
                  <p className="text-sm text-slate-400 font-sans">
                    Müvekkil mahremiyeti ve meslek sırrı, çalışma prensiplerimizin temelidir.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="bg-amber-700 text-white hover:bg-amber-800 border-none">
                <Link to="https://celikhukuk.net/iletisim/">
                  İletişime Geçin <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={cn("lg:col-span-5 relative mt-12 lg:mt-0 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="relative z-10 rounded-sm overflow-hidden shadow-2xl border border-white/5 bg-card">
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0c10]/80 via-transparent to-transparent z-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568729/img/office_interior_modern_dark.png" alt="Av. Arb. Muhammed Çelik Hukuk Bürosu Ofis İçi" className="w-full h-auto object-cover aspect-[4/5] hover:scale-105 transition-transform duration-700" />
              
              {}
              <div className="absolute bottom-8 left-8 z-20 bg-[#0a0c10]/90 backdrop-blur-md border border-white/10 p-6 max-w-[280px] shadow-xl">
                <p className="text-2xl font-serif font-bold text-slate-300 mb-1">7+</p>
                <p className="text-sm text-slate-400 uppercase tracking-wide font-medium font-sans">
                  Yıllık Tecrübe ve<br />Kesintisiz Hizmet
                </p>
              </div>
            </div>

            {}
            <div className="absolute -top-12 -right-12 w-full h-full border-2 border-amber-900/10 z-0 hidden lg:block" />
            <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-amber-900/5 rounded-full blur-2xl z-0" />
          </div>
        </div>
      </div>
    </section>;
}